var map = {
	"./icn_borchie.svg": "2824",
	"./icn_brillanti.svg": "639c",
	"./icn_bucket.svg": "0527",
	"./icn_charms.svg": "94af",
	"./icn_close.svg": "a73b",
	"./icn_drag.svg": "dc81",
	"./icn_eraser.svg": "3760",
	"./icn_erases.svg": "1087",
	"./icn_highlighter.svg": "55f6",
	"./icn_lightMarker.svg": "1347",
	"./icn_quotes.svg": "7280",
	"./icn_redo.svg": "a24e",
	"./icn_resize.svg": "53af",
	"./icn_resize_pens_tool.svg": "170c",
	"./icn_smudge.svg": "9de6",
	"./icn_stickers.svg": "889b",
	"./icn_strongMarker.svg": "b0d1",
	"./icn_undo.svg": "dbeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2101";